




































































































import { Component } from 'vue-property-decorator';
import * as StringUtil from '@/common/StringUtil';
import RepositoryFactory from '@/repository/RepositoryFactory';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamNav from '@/components/ExamNav.vue';
import ExamReadyEntry from '@/models/entry/ExamReadyEntry';
import ExamReadyRank from '@/models/entry/ExamReadyRank';
import ExamRankDetail from '@/models/rank/ExamRankDetail';

import * as Msgs from '@/common/Messages';
import * as JwtUtil from '@/common/JwtUtil';

import IndicatorModal from '@/components/IndicatorModal.vue';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class ExamReady extends BaseView {
  isIndicatorDisplay = false;

  rankDetail = new ExamRankDetail();

  rank = new ExamReadyRank();

  canStartExamination = false;

  displayStyle = { display: 'none' };

  entryCode = '';

  examTitle = '';

  inPeriod = false;

  childTab: Window | null = null;

  private async created() {
    this.isIndicatorDisplay = true;

    // 受験申込コードがない場合強制敵にTOPへ飛ばす
    if (!this.$route.query.examination_entry_code) {
      this.$router.replace(this.paths.TOP);
    }

    // コールバックの場合thanksメッセージ表示
    if (this.$route.query.is_callback === '1') {
      this.displayStyle = { display: 'block' };
    }

    try {
      const jwt = JwtUtil.getJwtInfo();

      // 検定タイトル設定
      await this.getExam();

      if (!StringUtil.isEmpty(this.$route.query.rank)) {
        await this.getRankInfo(String(this.$route.query.rank));
      }

      this.entryCode = String(this.$route.query.examination_entry_code);
      if (this.rankDetail.registrationRequired) {
        // 受験情報取得
        await this.getEntryInfo(this.entryCode);
      } else {
        // アカウント不要受験情報取得
        await this.getGuestEntryInfo(this.entryCode);
      }
    } catch (error) {
      this.$router.replace(this.paths.TOP);
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  private mounted() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ReadyCss = document.createElement('link');
    ReadyCss.rel = 'stylesheet';
    ReadyCss.href = '/exam/css/ready.css';
    this.$el.appendChild(ReadyCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 検定情報取得
   */
  private async getExam() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      await ExamRepository.getExam().then((response) => {
        this.examTitle = response.data.exam_title;
        this.inPeriod = response.data.in_period;
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * ランク情報を取得します
   *
   * @param rankCode ランクコード
   */
  private async getRankInfo(rankCode: string) {
    try {
      const RankRepository = RepositoryFactory.get().rank;
      await RankRepository.getRankInfo(rankCode).then((response) => {
        if (response.status === 200) {
          try {
            this.rankDetail = RankRepository.convert.deserialize(response.data, ExamRankDetail) as ExamRankDetail;
          } catch (e) {
            throw Error(Msgs.INVALID_RESPONSE);
          }
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 申込情報を取得します
   *
   * @param entryCode 申込コード
   */
  private async getEntryInfo(entryCode: string) {
    try {
      const EntryRepo = RepositoryFactory.get().entry;
      await EntryRepo.getEntryWithEntryCode(entryCode)
        .then((response) => {
          if (response.status === 200 && response.data !== undefined) {
            const tempEntry = EntryRepo.convert.deserializeObject(response.data, ExamReadyEntry);
            this.canStartExamination = tempEntry.canStartExamination;
            this.rank = tempEntry.examRank;
            this.rank.periodStart = StringUtil.toJapanDateString(this.rank.periodStart);
            this.rank.periodEnd = StringUtil.toJapanDateString(this.rank.periodEnd);
          } else {
            this.$router.replace(this.paths.TOP);
          }
        })
        .catch(() => {
          this.$router.replace(this.paths.TOP);
        });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * アカウント不要申込情報を取得します
   *
   * @param entryCode 申込コード
   */
  private async getGuestEntryInfo(entryCode: string) {
    try {
      const GuestRepository = RepositoryFactory.get().guest;
      await GuestRepository.getGuestEntry(entryCode)
        .then((response) => {
          if (response.status === 200 && response.data !== undefined) {
            const tempEntry = GuestRepository.convert.deserializeObject(response.data, ExamReadyEntry);
            this.canStartExamination = tempEntry.canStartExamination;
            this.rank = tempEntry.examRank;
            this.rank.periodStart = StringUtil.toJapanDateString(this.rank.periodStart);
            this.rank.periodEnd = StringUtil.toJapanDateString(this.rank.periodEnd);
          } else {
            this.$router.replace(this.paths.TOP);
          }
        })
        .catch(() => {
          this.$router.replace(this.paths.TOP);
        });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 検定ページを別ウィンドウで開く
   */
  startExam() {
    if (this.childTab !== null) {
      alert('既にクイズが開始されています');
      return;
    }

    let path = `?rank=${StringUtil.encodeToBase64Url(this.rank.rankCode)}&entry=${this.entryCode}`;
    if (this.rankDetail.registrationRequired) {
      path = `${this.paths.EXAM}${path}`;
    } else {
      path = `${this.paths.GUEST_EXAM}${path}`;
    }
    // 新しく開いたwindowオブジェクトを保持
    this.childTab = window.open(path, `exam${Date.now()}`);
  }

  /**
   * モーダルを閉じる
   */
  modalClose() {
    this.displayStyle = { display: 'none' };
  }
}
